'use client';

import PlainServiceLayout from '@/components/layout/service/PlainServiceLayout';

interface PolicyLayoutProps {
    children: React.ReactNode;
}

export default function layout({ children }: PolicyLayoutProps) {
    return <PlainServiceLayout>{children}</PlainServiceLayout>;
}
